import { formatLivestreamStartSchedule } from "./livestreamSchedule";

export function LivestreamStartDateDisplay({
  start,
}: {
  start?: string | null;
}) {
  if (!start) return null;

  const schedule = formatLivestreamStartSchedule({ start });
  if (!schedule) return null;

  return (
    <div className="mt-3 space-y-0.5">
      <p className="text-base text-white/70">{schedule.date}</p>
      <p className="text-sm text-gray-400">{schedule.time}</p>
    </div>
  );
}
